export class Deferred<T> {
  public resolved = false;

  public get promise(): Promise<T> {
    return this._promise;
  }

  //@ts-ignore
  private _reject: (reason?: unknown) => void;
  //@ts-ignore
  private _resolve: (value: T) => void;
  private _promise: Promise<T>;

  private constructor() {
    this._promise = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  public resolve(value: T) {
    this.resolved = true;
    this._resolve(value);
  }

  public reject(reason?: unknown) {
    this.resolved = true;
    this._reject(reason);
  }
  public static defer<T>(): Deferred<T> {
    return new Deferred<T>();
  }
}
